"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; //
//
//
//
//
//

var _default = {
  name: 'content-section',
  props: ['name']
};
exports["default"] = _default;